import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const dotBounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
  40%           { transform: translateY(-4px); opacity: 1; }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#f9fafb')};
  z-index: 50;
`;

export const SpinnerWrapper = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(26, 77, 77, 0.3)' : 'rgba(26, 77, 77, 0.15)')};
  border-top-color: #1a4d4d;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LoadingDots = styled.div`
  display: flex;
  gap: 4px;
`;

export const LoadingDot = styled.div<{ $delay: number }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1a4d4d;
  animation: ${dotBounce} 1.2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;

export const LoadingText = styled.span`
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
  letter-spacing: 0.3px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

export const Title = styled.h3`
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1f2937')};
  line-height: 1.5;
  margin: 0;
`;

export const Description = styled.p`
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  line-height: 1.6;
  margin: 0;
`;
